document.addEventListener('variant:update', (event) => {
  const productId = event.detail?.data?.productId;
  if (!productId) return;

  const html = event.detail?.data?.html;
  if (!html) return;

  const newStatus = html.querySelector('inventory-status');
  const currentStatus = document.querySelector('inventory-status');
  
  currentStatus.replaceWith(newStatus);
});